// Common text constants shared across the application
// Centralized text management for easy localization and updates

export const COPYRIGHT_TEXT = '© 2026 Logitech. Reservados todos los derechos.';

export const storeNames = {
    logitechArgentina: "Logitech Argentina",
    fullh4rd: "Fullh4rd",
    insumosacuario: "Insumos Acuario",
    mercadolibre: "Tienda Oficial (MELI)",
    mesajil: "Mesajil",
    memorykings: "Memory Kings",
    ibeam: "IBEAM Store",
    tecnomas: "Tecnomas",
    logitech: "Logitech Store Colombia",
    alkosto: "Alkosto",
    panamericana: "Panamericana",
    disayko: "Disayko",
    pacifiko: "Pacifiko",
    intelec: "Intelec",
    unimart: "Unimart",
    kemik: "Kemik",
} as const;

export type StoreName = (typeof storeNames)[keyof typeof storeNames];

export const storesByCountry: Record<string, { name: StoreName; url: string }[]> = {
    ar: [
        { name: storeNames.logitechArgentina, url: "https://www.logitechargentina.com.ar/collections/series-ergo" },
        { name: storeNames.mercadolibre, url: "https://www.mercadolibre.com.ar/tienda/logitech" },
        { name: storeNames.insumosacuario, url: "https://insumosacuario.com.ar/micrositios/logitech/" },
        { name: storeNames.fullh4rd, url: "https://fullh4rd.com.ar/logitech-ergo/" },
    ],
    cl: [
        { name: storeNames.ibeam, url: "https://ibeam.cl/search?q=ERGO" },
        { name: storeNames.mercadolibre, url: "https://www.mercadolibre.cl/tienda/logitech#origin=search_intervention&tracking_id=9f0263c9-dd31-48a2-8540-27be29efc021" },
        { name: storeNames.tecnomas, url: "https://www.tecnomas.cl/productos?q=logitech+ergo" },
    ],
    pe: [
        { name: storeNames.mercadolibre, url: "https://listado.mercadolibre.com.pe/ergo_CustId_3244910986_NoIndex_True?sb=seller_id&tracking_id=2ac57778-2b75-4169-bcf5-1b1916be8c4d#D%5BA%3AERGO%5D=&component=category_gallery&page_from=home&label=SERIE+ERGO&custom_categories=false&global_position=8" },
        { name: storeNames.mesajil, url: "https://mesajil.com/?s=logitech+ergo&post_type=product&dgwt_wcas=1" },
        { name: storeNames.memorykings, url: "https://www.memorykings.pe/resultados/logitech+ergo" },
    ],
    co: [
        { name: storeNames.logitech, url: "https://www.logitechstore.com.co/collections/series-ergo" },
        { name: storeNames.mercadolibre, url: "https://listado.mercadolibre.com.co/tienda/logitech/ergo?sb=storefront_url" },
        { name: storeNames.alkosto, url: "https://www.alkosto.com/search?text=logitech%20ergo&sort=price-desc" },
        { name: storeNames.panamericana, url: "https://www.panamericana.com.co/logitech%20mx?_q=logitech%20mx&map=ft" },
        { name: storeNames.disayko, url: "https://www.disayko.com/logitech/" },
    ],
    cr: [
        { name: storeNames.pacifiko, url: "https://www.pacifiko.cr/index.php?category_id=0&search=ergo%20logitech&submit_search=&route=product%2Fsearch&document_id=1790629480224" },
        { name: storeNames.intelec, url: "https://www.intelec.co.cr/?s=ergo+logitech&post_type=product&dgwt_wcas=1" },
        { name: storeNames.unimart, url: "https://www.unimart.com/search?q=logitech+ergo" },
    ],
    gt: [
        { name: storeNames.kemik, url: "https://www.kemik.gt/search?query=ergo%20logitech" },
    ],
};